import React from 'react';
import PropTypes from 'prop-types';

const MatrixFooter = ({
  isDirty,
  saving,
  optionCount,
  venueCount,
  venuesWithDefault,
  onCancel,
  onSave,
}) => (
  <div className="ar-card__footer">
    <div className="ar-card__footer-meta">
      {optionCount} options · {venueCount} venues · {venuesWithDefault}/{venueCount} have a default set
    </div>
    <div className="ar-card__footer-actions">
      <button
        type="button"
        className="ar-btn ar-btn--secondary"
        onClick={onCancel}
        disabled={!isDirty || saving}
      >
        Cancel
      </button>
      <button
        type="button"
        className="ar-btn ar-btn--primary"
        onClick={onSave}
        disabled={!isDirty || saving}
      >
        {saving ? 'Saving…' : 'Save changes'}
      </button>
    </div>
  </div>
);

MatrixFooter.propTypes = {
  isDirty: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  optionCount: PropTypes.number.isRequired,
  venueCount: PropTypes.number.isRequired,
  venuesWithDefault: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default MatrixFooter;
